import cjquery from 'jquery';
import React, { Component } from 'react';
import language from '../assets/languages/language';
import TooltipItem from '../views/ESG/Dashboard/Tooltip';
import App_data from '../views/config/App_data';
import FD from '../views/RestAPI/fetchData';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { showFailure, showSuccess } from '../common/toast';
const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
export default class FlashCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: '',
      id_name: '',
      token: '',
      flashData: {},
      isFlashCardHidden: props.isFlashCardHidden,
      isFlashEditMode: false,
      isLoading: false,
      isDeleteModal: false,
    };
  }
  componentDidMount() {
    if (storage_session) {
      const { token = '', idname: id_name } = storage_session;
      this.setState(
        {
          id_name,
          token,
        },
        () => {
          this.getFlashcard();
        },
      );
    }
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.item.id !== this.props.item.id) {
      this.setState({ isFlashEditMode: false });
      await this.getFlashcard();
    }
  }
  toggleFlash = () => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };
  onHandleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  //* {{ GET }}   FLASHCARD FUNCTIONALITY STARTED HERE
  getFlashcard = async () => {
    const { id_name, token } = this.state;
    const { type = '', question_type = '', exam = '', level = '', item = {} } = this.props;
    const { id = '' } = item;
    const payload = {
      id_name,
      token,
      type,
      question_type,
      exam,
      level,
      item_id: id,
    };
    const getFlashCard = await FD.callAPI(
      `${App_data.backend_api}/question_bank_2024/getFlashcards`,
      payload,
    );
    if (getFlashCard.success) {
      this.setState({ flashData: getFlashCard.flash_cards, comment: '', isFlashEditMode: false });
    } else {
      this.setState({ flashData: {}, comment: '', isFlashEditMode: false });
    }
  };
  //* {{ SAVE }}  FLASHCARD FUNCTIONALITY STARTED HERE
  saveFlashCard = async () => {
    try {
      this.setState({ isLoading: true });
      const { comment, id_name, token } = this.state;
      const { type = '', question_type = '', exam = '', level = '', item = {} } = this.props;
      const { id = '' } = item;
      const payload = {
        id_name,
        token,
        type,
        question_type,
        exam,
        level,
        flash_card: comment,
        item_id: id,
      };
      //* API CALLED HERE FOR SAVE FLASHCARD COMMENT
      const saveFlashCard = await FD.callAPI(
        `${App_data.backend_api}/question_bank_2024/saveFlashCard`,
        payload,
      );
      if (saveFlashCard.success) {
        this.setState({ flash_data: '', isLoading: false }, () => {
          showSuccess(saveFlashCard.message);
          this.getFlashcard();
        });
      } else {
        this.setState({ isLoading: false });
      }
    } catch (error) {
      showFailure(error.message);
      this.setState({ isLoading: false });
    }
  };
  //* {{ EDIT }}  FLASHCARD FUNCTIONALITY STARTED HERE
  editFlash = async () => {
    const { flashData } = this.state;
    if (flashData.item_id) {
      this.setState({ comment: flashData.flash_card, isFlashEditMode: true }, () => {
        this.setState({ flashData: '' });
      });
    }
  };
  //* {{ DELETE}} FLASHCARD FUNCTIONALITY STARTED HERE
  deleteFlash = async () => {
    try {
      this.setState({ isLoading: true });
      const { id_name, token } = this.state;
      const { type = '', question_type = '', exam = '', level = '', item = {} } = this.props;
      const { id = '' } = item;
      const payload = {
        id_name,
        token,
        type,
        question_type,
        exam,
        level,
        item_id: id,
      };
      const response = await FD.callAPI(
        `${App_data.backend_api}/question_bank_2024/deleteFlashCard`,
        payload,
      );
      if (response.success) {
        showSuccess(response.message);
      }
      this.setState({
        flashData: {},
        comment: '',
        isFlashEditMode: false,
        isDeleteModal: false,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        flashData: {},
        comment: '',
        isFlashEditMode: false,
        isDeleteModal: false,
        isLoading: false,
      });
      showFailure(error.message);
    }
  };

  render() {
    const { comment, flashData, isFlashEditMode, isLoading, isDeleteModal } = this.state;
    const { isFlashCardHidden } = this.props;

    return (
      !isFlashCardHidden && (
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-header pointer_class' onClick={this.toggleFlash}>
              {language.LC().FLASHCARD} {'  '}
              <TooltipItem
                placement={'top'}
                content={language.LC().FLASHCARD_TOOLTIP_MESSAGE}
                place_tip={'top'}
                tooltipId={'1'}
              />
              <div className='float-right text-right'>
                <img src={`${App_data.frontend_url}/img/arrow_down_ico.png`} className='' alt='' />
              </div>
            </div>
            {
              <div ref='flash_toggle_div'>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-xs-12 col-sm-12 col-md-12'>
                      {/* <ul className='comment_list_wrapper'>{this.state.flash_data}</ul> */}
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-12'>
                      {flashData.item_id ? (
                        <div className='row'>
                          <div className='comment_content col-md-10'>
                            <p>{flashData.flash_card}</p>
                          </div>
                          <ul className='icon_list col-md-2'>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={() => this.editFlash(flashData)}
                              >
                                <i className='fa fa-pencil' />
                              </a>
                            </li>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={() => this.setState({ isDeleteModal: true })}
                              >
                                <i className='fa fa-close' />
                              </a>
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <form>
                          <textarea
                            id='flash_card'
                            name='comment'
                            value={comment}
                            rows='6'
                            className='form-control margin_bottom_10 card'
                            placeholder='Your flash card here'
                            onChange={this.onHandleChange}
                          />
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class'
                            style={{ float: 'right' }}
                            disabled={isLoading}
                            onClick={this.saveFlashCard}
                          >
                            {isFlashEditMode
                              ? isLoading
                                ? 'Updating...'
                                : 'Update'
                              : isLoading
                              ? 'Creating...'
                              : language.LC().CREATE}
                          </button>
                          {isFlashEditMode && (
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class'
                              style={{ float: 'right' }}
                              onClick={() => this.getFlashcard()}
                            >
                              Cancel
                            </button>
                          )}
                          <p style={{ color: '#6d6d6dde', fontSize: '12px' }}>
                            {
                              language.LC()
                                .FLASHCARDS_ONLY_SHOW_UP_TO_YOU_This_is_a_simple_way_to_take_notes_while_you_study
                            }
                          </p>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <Modal
            isOpen={isDeleteModal}
            // toggle={this.toggleAlertReport}
            className={'modal-primary '}
          >
            <ModalHeader>
              Alert
              <button
                type='button'
                className='close'
                aria-label='Close'
                onClick={() => this.setState({ isDeleteModal: !this.state.isDeleteModal })}
              >
                <span aria-hidden='true'>×</span>
              </button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{'Are you sure you want to delete this?'}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  disabled={isLoading}
                  onClick={() => this.deleteFlash(flashData)}
                >
                  {isLoading ? 'Deleting...' : 'Ok'}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FlashCard.js